import Api from './api';
import {appId} from '../store';

export const createPayPalOrder = async (packId) => {
  const order = await Api.post('/game/app/:appId/payment/order', {
    packId,
  }, {appId});

  return order;
};

export const capturePayPalTransaction = async ({
  captureId, orderId, payerId, payerEmail,
}) => {
  const coins = await Api.post('/game/app/:appId/payment/capture', {
    captureId,
    orderId,
    payerId,
    payerEmail,
  }, {appId});

  return coins;
};
